<div class="router-nav">
  <div class="nav-headings">
    @for (l of list; track l) {
    <button mat-button color="accent" id="{{ l['Text'] }}" type="button" class="nav-button ellipsis" (click)="navLinkClicked(l['Text'])">{{ l['Text'] }}</button>
    }
  </div>
  <mat-divider></mat-divider>
  <div class="nav-body">
    @if (list != null && list.length > 0 && list.length > activeTab) {
    <div>
      <mat-list>
        @for (item of list[activeTab]['Links']; track item; let i = $index) {
        <mat-list-item>
          <button
            [ngClass]="{ 'disabled-cursor': disabled == true, 'pointer': !disabled }"
            mat-raised-button
            type="button"
            class="list-button ellipsis"
            (click)="pageClicked(item)"
          >
            <span class="ellipsis">
              {{ item.Text }}
              @if (item.Active) {
              <mat-icon class="material-icons activeArrow pull-right">arrow_right</mat-icon>
              }
            </span>
            <!-- <span ></span> -->
          </button>
        </mat-list-item>
        }
      </mat-list>
    </div>
    }
  </div>
</div>
